import { Divider, List, ListItem, ListItemText, Typography } from '@mui/material'

const Title = () => {
  return (
    <>
    <Typography variant="h3" fontWeight="bold" gutterBottom>
        Privacy Policy
    </Typography>
    <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
        Keel Info Solution Private Limited (“we”, “our”, “us”) is committed to protecting 
        your personal information and ensuring transparency in how we collect, use, 
        store, and manage that information. This Privacy Policy explains the types of 
        data we collect through our mobile application and web platform Spot My 
        Team – ME Foods (“the App”), how that data is used, and your rights 
        concerning your personal information.
        By accessing and using the App, you agree to the practices described in this 
        Privacy Policy. This policy applies to all users of the App, including sales 
        representatives, field agents, admins, and employees of organizations using 
        our services.
        This Privacy Policy complies with applicable Indian data protection laws, 
        including the Information Technology Act, 2000, and the Information 
        Technology (Reasonable Security Practices and Procedures and Sensitive 
        Personal Data or Information) Rules, 2011.
    </Typography>
          <Divider sx={{ my: 2 }} />
    <Typography variant="h4" fontWeight="bold" gutterBottom>
        1. Definitions
    </Typography>
    <List>
        <ListItem>
            <ListItemText>
             <b> • User(s) : </b>   
            User(s): Individuals using the Spot My Team – ME FoodsApp, including 
            employees, sales teams, and managers.
            </ListItemText>
        </ListItem>
        <ListItem>
            <ListItemText> 
                <b>• Customer(s) : </b>  Organizations or businesses that license and use the App for 
                workforce and customer operations.

            </ListItemText>
        </ListItem>
        <ListItem>
            <ListItemText>
                <b>• Administrator(s) : </b>
                Authorized individuals from the customer’s organization 
                responsible for managing user accounts and data within the App.
            </ListItemText>
        </ListItem>
        <ListItem>
            <ListItemText>
                <b>
                • Personal Information:
                </b>
                Any information that can identify a person, such as 
                name, phone number, email, and location.
            </ListItemText>
        </ListItem>
        <ListItem>
            <ListItemText>
                <b>
                • Business Data : 
                </b>
                Information related to sales, orders, payments, customer 
                visits, and work activities.
            </ListItemText>
        </ListItem>
        <ListItem>
            <ListItemText>
                <b>
                • Services : 
                </b>
                Functionalities of the App including check-in/out, customer visits, 
                sales order and payment collection, product inventory management, and 
                report generation.
            </ListItemText>
        </ListItem>
    </List>
  <Divider sx={{ my: 2 }} />
    </>
  )
}

export default Title